import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import analytics, { EVENTS } from '../services/analytics';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation('common');
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', name: t('language.en'), flag: '🇬🇧' },
    { code: 'fr', name: t('language.fr'), flag: '🇫🇷' },
    { code: 'de', name: t('language.de'), flag: '🇩🇪' },
    { code: 'es', name: t('language.es'), flag: '🇪🇸' },
    { code: 'it', name: t('language.it'), flag: '🇮🇹' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleLanguageChange = (langCode) => {
    const previousLanguage = i18n.language;
    i18n.changeLanguage(langCode);
    setIsOpen(false);
    // Save to localStorage
    localStorage.setItem('orram-language', langCode);

    // Track language change
    analytics.track(EVENTS.LANGUAGE_CHANGED, {
      new_language: langCode,
      previous_language: previousLanguage
    });
    analytics.setUserProperties({ language: langCode });
  };

  return (
    <div className="language-switcher">
      <button
        className="language-switcher-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-label={t('language.select')}
      >
        <span className="language-code">{currentLanguage.code.toUpperCase()}</span>
        <svg
          className={`language-chevron ${isOpen ? 'open' : ''}`}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4 6L8 10L12 6"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isOpen && (
        <>
          <div
            className="language-switcher-overlay"
            onClick={() => setIsOpen(false)}
          />
          <div className="language-switcher-dropdown">
            {languages.map((lang) => (
              <button
                key={lang.code}
                className={`language-option ${
                  lang.code === i18n.language ? 'active' : ''
                }`}
                onClick={() => handleLanguageChange(lang.code)}
              >
                <span className="language-code">{lang.code.toUpperCase()}</span>
                <span className="language-name">{lang.name}</span>
                {lang.code === i18n.language && (
                  <svg
                    className="language-check"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 4L6 11L3 8"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSwitcher;
